<template>
  <span
    class="chart-tooltip"
    @mouseenter="show"
    @mouseleave="hideIfNotPinned"
    @click="toggle"
  >
    <slot />
    <div
      v-if="visible"
      ref="bubble"
      class="chart-tooltip__bubble"
      :class="`chart-tooltip__bubble--${placement}`"
    >
      <slot name="content">
        {{ label }}
      </slot>
    </div>
  </span>
</template>

<script>
export default {
  name: 'BaseChartTooltip',
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      pinned: false,
      placement: 'top'
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick, true)
  },
  methods: {
    show() {
      this.visible = true
      this.$nextTick(this.updatePlacement)
    },
    hideIfNotPinned() {
      if (!this.pinned) {
        this.visible = false
      }
    },
    toggle(event) {
      event.stopPropagation()
      this.pinned = !this.pinned
      this.visible = this.pinned
      if (this.pinned) {
        this.$nextTick(this.updatePlacement)
        document.addEventListener('click', this.onDocumentClick, true)
      } else {
        document.removeEventListener('click', this.onDocumentClick, true)
      }
    },
    onDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.pinned = false
        this.visible = false
        document.removeEventListener('click', this.onDocumentClick, true)
      }
    },
    updatePlacement() {
      const bubble = this.$refs.bubble
      if (!bubble) {
        return
      }
      const rect = bubble.getBoundingClientRect()
      this.placement = rect.top < 8 ? 'bottom' : 'top'
    }
  }
}
</script>

<style lang="scss">
.chart-tooltip {
  position: relative;
  display: inline-flex;

  &__bubble {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    background: rgba(97, 97, 97, 0.95);
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.4;
    padding: 5px 9px;
    border-radius: 5px;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
    }

    &--top {
      bottom: calc(100% + 8px);

      &::after {
        top: 100%;
        border-top-color: rgba(97, 97, 97, 0.95);
      }
    }

    &--bottom {
      top: calc(100% + 8px);

      &::after {
        bottom: 100%;
        border-bottom-color: rgba(97, 97, 97, 0.95);
      }
    }
  }
}
</style>
